let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3lHF0")).then(() => parcelRequire('laIek'));